

// import React, { useEffect, useState } from 'react';
// import './Gallery.css'; // Import CSS file for styling

// const Gallery = () => {
//   const [images, setImages] = useState([]);
//   const [approvedImages, setApprovedImages] = useState([]); // To hold approved images

//   // Fetch non-approved images
// const fetchImages = async () => {
//   try {
//     const dist = sessionStorage.getItem("dist");
//     const response = await fetch(`https://lionsdirectoryapi.emedha.in/gallery/api/gallery/not-approved?dist=${dist}`);
//     const data = await response.json();
//     setImages(data);
//   } catch (error) {
//     console.error('Error fetching non-approved images:', error);
//   }
// };


//   // Fetch approved images
// const fetchApprovedImages = async () => {
//   try {
//     const dist = sessionStorage.getItem("dist");
//     const response = await fetch(`https://lionsdirectoryapi.emedha.in/gallery/api/gallery/approved?dist=${dist}`);
//     const data = await response.json();
//     setApprovedImages(data);
//   } catch (error) {
//     console.error('Error fetching approved images:', error);
//   }
// };


//   useEffect(() => {
//     fetchImages();
//     fetchApprovedImages();
//   }, []);

//   // Approve an image
// const handleApprove = async (id) => {
//   try {
//     const dist = sessionStorage.getItem("dist");
//     const response = await fetch(`https://lionsdirectoryapi.emedha.in/gallery/api/approve/${id}?dist=${dist}`, {
//       method: 'POST',
//     });
//     if (response.ok) {
//       console.log(`Image ${id} approved.`);
//       alert(`Image Successfully Approved.`);
//       fetchImages();
//       fetchApprovedImages();
//     } else {
//       console.error('Error approving image:', await response.json());
//     }
//   } catch (error) {
//     console.error('Error approving image:', error);
//   }
// };


//   // Delete an image
//   const handleDelete = async (id, status) => {
//     try {
//       const url = status === 'Approved' 
//         ? `https://lionsdirectoryapi.emedha.in/gallery/api/delete/${id}` 
//         : `https://lionsdirectoryapi.emedha.in/gallery/api/delete/${id}`;

//       const response = await fetch(url, { method: 'DELETE' });
//       if (response.ok) {
//         console.log(`Image ${id} deleted.`);
//         alert(`Image successfully deleted.`);
//         fetchImages(); // Refresh non-approved images
//         fetchApprovedImages(); // Refresh approved images
//       } else {
//         console.error('Error deleting image:', await response.json());
//       }
//     } catch (error) {
//       console.error('Error deleting image:', error);
//     }
//   };

//   return (
// <div className="gallery-container">
// {/* <h1 style={{ color: "rgb(245, 170, 30)" }}>Image Gallery</h1> */}
//   {/* Non-Approved Images Section */}
//   <h2 style={{color:'#ff8c00',marginTop:'0px'}}>Non-Approved Images</h2>
//   <div className="gallery-grid">
//     {images.length === 0 ? (
//       <p className="no-images-message">No non-approved images available.</p> // Centered text when no images
//     ) : (
//       images.map((image) => (
//         <div key={image.id} className="gallery-item">
//           <img src={image.image} alt={`Image ${image.id}`} className="gallery-image" />
//           <div className="image-details">
//     <h3 className="image-title">{image.title}</h3>
//     <p><strong>Description:</strong> {image.description}</p>
//     <p><strong>Club:</strong> {image.club_name}</p>
//     <p><strong>Category:</strong> {image.category}</p>
//     <p>
//       <strong>Created At:</strong>{" "}
//       {new Date(image.created_at).toLocaleString()}
//     </p>
//   </div>
//           <div className="button-container">
//             <button className="approve-button" onClick={() => handleApprove(image.id)}>
//               Approve
//             </button>
//             <button className="delete-button" onClick={() => handleDelete(image.id, 'Not Approved')}>
//               Delete
//             </button>
//           </div>
//         </div>
//       ))
//     )}
//   </div>

//   {/* Margin between sections */}
//   <div style={{ marginTop: '30px' }}></div>

//   {/* Approved Images Section */}
//   <h2 style={{color:'#ff8c00'}}>Approved Images</h2>
//   <div className="gallery-grid">
//     {approvedImages.map((image) => (
//       <div key={image.id} className="gallery-item">
//         <img src={image.image} alt={`Image ${image.id}`} className="gallery-image" />
//         <div className="image-details">
//     <h3 className="image-title">{image.title}</h3>
//     <p><strong>Description:</strong> {image.description}</p>
//     <p><strong>Club:</strong> {image.club_name}</p>
//     <p><strong>Category:</strong> {image.category}</p>
//     <p>
//       <strong>Created At:</strong>{" "}
//       {new Date(image.created_at).toLocaleString()}
//     </p>
//   </div>
//         <div className="button-container">
//           <button className="delete-button" onClick={() => handleDelete(image.id, 'Approved')}>
//             Delete
//           </button>
//         </div>
//       </div>
//     ))}
//   </div>
// </div>

//   );
// };

// export default Gallery;

import React, { useEffect, useState } from "react";
import "./Gallery.css";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [approvedImages, setApprovedImages] = useState([]);

  const fetchImages = async () => {
    try {
      const dist = sessionStorage.getItem("dist");
      const res = await fetch(`https://lionsdirectoryapi.emedha.in/gallery/api/gallery/not-approved?dist=${dist}`);
      const data = await res.json();
      setImages(data);
    } catch (err) {
      console.error("Error fetching non-approved images:", err);
    }
  };

  const fetchApprovedImages = async () => {
    try {
      const dist = sessionStorage.getItem("dist");
      const res = await fetch(`https://lionsdirectoryapi.emedha.in/gallery/api/gallery/approved?dist=${dist}`);
      const data = await res.json();
      setApprovedImages(data);
    } catch (err) {
      console.error("Error fetching approved images:", err);
    }
  };

  useEffect(() => {
    fetchImages();
    fetchApprovedImages();
  }, []);

  const handleApprove = async (id) => {
    try {
      const dist = sessionStorage.getItem("dist");
      const res = await fetch(`https://lionsdirectoryapi.emedha.in/gallery/api/approve/${id}?dist=${dist}`, { method: "POST" });
      if (res.ok) {
        alert("Image successfully approved!");
        fetchImages();
        fetchApprovedImages();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`https://lionsdirectoryapi.emedha.in/gallery/api/delete/${id}`, { method: "DELETE" });
      if (res.ok) {
        alert("Image deleted successfully!");
        fetchImages();
        fetchApprovedImages();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="gallery-container">
      <h2>Non-Approved Images</h2>
      <div className="gallery-grid">
        {images.length === 0 && <p className="no-images-message">No non-approved images available.</p>}
        {images.map((img) => (
          <div key={img.id} className="gallery-card">
            <img src={img.image} alt={img.title} className="gallery-image" />
            <div className="overlay">
              <div className="image-info">
                <h3>{img.title}</h3>
                <p>{img.club_name} • {formatDate(img.created_at)}</p>
                <p>{img.category}</p>
              </div>
              <div className="overlay-buttons">
                <button className="approve-btn" onClick={() => handleApprove(img.id)}>Approve</button>
                <button className="delete-btn" onClick={() => handleDelete(img.id)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h2>Approved Images</h2>
      <div className="gallery-grid">
        {approvedImages.map((img) => (
          <div key={img.id} className="gallery-card">
            <img src={img.image} alt={img.title} className="gallery-image" />
            <div className="overlay">
              <div className="image-info">
                <h3>{img.title}</h3>
                <p>{img.club_name} • {formatDate(img.created_at)}</p>
                <p>{img.category}</p>
              </div>
              <div className="overlay-buttons">
                <button className="delete-btn" onClick={() => handleDelete(img.id)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;